import React, { useEffect, useMemo, useState } from "react";
import TextLabel from "./TextLabel";
import DatatTable from "./TableNoStyle";
import { t } from "i18next";
import { minutesToHHMMSS } from "./DateUtils";
import Card from "react-bootstrap/Card";
import { CardHeader } from "react-bootstrap";
import Box from "@material-ui/core/Box";
import ReactModal from "./Modal/AddModalCustomer";
import useAddModal from "../../hooks/useAddModal";
import ShowResolverInfoModal from "./Modal/ShowResolverInfoModal";
import {
  apiHostUrl,
  getUserListfromGroupNameURL,
} from "../../../constants/constants";
import useAxiosFetchData from "../../hooks/useAxiosFetchData";
import { useSelector } from "react-redux";

const tableStyles = {
  width: " 100%",
  height: "auto",
  minWidth: "0",
};

function ResolutionTarget({ onClickRow, resolutionPayload, blockSelect }) {
  const { isOpen, val, toggleModal } = useAddModal();
  const [filteredRows, setFilteredRows] = useState([]);
  const [row, setRow] = useState([]);
  const [selectedRowss, setSelectedRowss] = useState([]);
  const { csrfToken } = useSelector((state) => state.csrf);
  const { homeLink } = useSelector((state) => state.role);
  const [headers, setHeaders] = useState({
    "X-Csrf-Token": csrfToken,
    "Content-Type": "application/json",
  });
  const [userListFormData, setUserListFormData] = useState(null);
  //   useEffect(() => {
  //     setUserListFormData(prevState => ({
  //       ...prevState,

  //       department: {
  //         id: data?.feedbackDetails?.department?.id
  //       },
  //       id: data?.receiptDetails[0]?.assigneeGroup?.id,
  //     }));
  //   }, [data]);
  const [isSelected, setIsSelected] = useState(false);
  const { fetchData: userListFeedbackResponse } = useAxiosFetchData({
    url: `${apiHostUrl}${homeLink}${getUserListfromGroupNameURL}`,
    method: "post",
    body: userListFormData,
    headers: headers,
    onLoad: false,
  });
  const columnData = useMemo(
    () => [
      // {
      //     accessorKey: 'radio',
      //     header: "",
      //     size: 60,
      // },
      {
        accessorKey: "step",
        header: t("feedbackDetails.step.text"),
        size: 60,

        // render: (row) => (
        //     <input
        //         type="checkbox"
        //         onChange={() => handleCheckboxChange(row.id)}
        //         checked={selectedRowss.includes(row.id)}
        //     />
        // ),
      },
      {
        accessorKey: "grp_name",
        header: t("feedbackDetails.groupName.text"),
        // size: props.size.sl_no,
      },
      {
        accessorKey: "ttime",
        header: t("feedbackDetails.targetTime.text") + "(HH:MM:SS)",

        // size:props.size.f_code,
      },
    ],
    []
  );

  const handleCheckboxChange = (event) => {
    // console.log(event);
    onClickRow(event);
    if (event.target.checked) {
      setIsSelected(true);
    }
    // setSelectedRowss((prevSelectedRows) => {
    //     if (prevSelectedRows.includes(id)) {
    //         return prevSelectedRows.filter((rowId) => rowId !== id);
    //     } else {

    //         return [...prevSelectedRows, id];
    //     }
    // });
  };
  const handleAssigneeView = (e, item) => {
    setUserListFormData({
      department: item.department,
      id: item.asigneeGroupId,
    });
  };
  useEffect(() => {
    if (userListFormData?.department?.id && userListFormData?.id) {
      userListFeedbackResponse().then((data) => {
        console.log(data);
        setRow(data);
        toggleModal();
      });
    }
  }, [userListFormData]);
  useEffect(() => {
    resolutionPayload.forEach((item, index) => {
      // const radio = (
      //     <input
      //         type="radio"
      //         onChange={handleCheckboxChange}
      //         checked={isSelected}

      //     />
      // );
      // {"asigneeGroupId":"547","assignmentTime":"16-02-2024 4:20 pm","departmentSlaId":"16274","minuteToCalculate":"30"}
      setFilteredRows((prevFilteredRows) => {
        return [
          ...prevFilteredRows,
          // step: "1",
          // assigneeName: "Auc_Resolver_Grp",
          // assignmentTime: moment().add(120, 'hours').format("DD-MM-YYYY hh:mm a"),
          // asigneeGroupId: "547",
          // asigneeId: "0",
          // departmentSlaId: "16275"
          {
            // radio: radio,
            step: item.step,
            grp_name: item.asigneeGroupId && (
              <div>
                <span>
                  {item.assigneeGroupName}
                  <i
                    class="ti ti-external-link fs-6 text-primary"
                    aria-hidden="true"
                    style={{ cursor: "pointer" }}
                    onClick={(e) => handleAssigneeView(e, item)}
                  ></i>
                </span>
              </div>
            ),
            ttime: minutesToHHMMSS(item.minuteToCalculate),
            assignmentTime: item.assignmentTime,
            asigneeGroupId: item.asigneeGroupId,
            asigneeId: item.asigneeId,
            departmentSlaId: item.departmentSlaId,
            minuteToCalculate: item.minuteToCalculate,
            assigneeGroupName: item.assigneeGroupName,
          },
        ];
      });
    });
  }, []);

  return (
    <Card className="overflow-hidden">
      <ReactModal
        size="sm"
        componentToRender={
          <ShowResolverInfoModal
            open={isOpen}
            handleClose={toggleModal}
            handleUserList={row}
          />
        }
        show={isOpen}
        handleClose={toggleModal}
        title={t("general.label.user.list")}
      />
      <CardHeader className="light-blue-bg">
        <TextLabel title={t("feedbackDetails.resolutionTarget.text")} />
      </CardHeader>
      <DatatTable
        onClickSelect={onClickRow}
        enableSelection={!blockSelect}
        tableStyles={tableStyles}
        tableData={{ columnData, rowsData: filteredRows }}
      ></DatatTable>
    </Card>
  );
}

export default ResolutionTarget;
